module.exports = __webpack_public_path__ + "static/media/bg-sommar.7873f002.jpg";